import type { ConfigurationsType } from "@dexteel/mesf-core/dist/configurationMenu";
import { useHasPermission } from "@dexteel/mesf-core";
import {
	Assignment,
	BarChart,
	Construction,
	MailOutline,
	TrendingUp,
	ViewQuilt,
	Warehouse,
} from "@mui/icons-material";
import {
	Divider,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	ListSubheader,
	useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import CraftsPage, { CRAFTS_PERMISSION } from "./configurations/crafts";
import EmailRecipientsPage from "./configurations/email-recipients";
import FormsPage from "./configurations/forms";
import ProductionStatisticsPage from "./configurations/production-statistics";
import ShelvesPage from "./configurations/shelves";
import StatisticsPage from "./configurations/statistics";
import TaskListAreasPage from "./configurations/task-list-areas";

const components = [
	{
		path: "task-list-areas",
		sidebar: () => <div>Task List Areas</div>,
		main: () => <TaskListAreasPage />,
	},
	{
		path: "crafts",
		sidebar: () => <div>Crafts</div>,
		main: () => <CraftsPage />,
	},
	{
		path: "forms",
		sidebar: () => <div>Forms</div>,
		main: () => <FormsPage />,
	},
	{
		path: "shelves",
		sidebar: () => <div>Shelves</div>,
		main: () => <ShelvesPage />,
	},
	{
		path: "statistics",
		sidebar: () => <div>Statistics</div>,
		main: () => <StatisticsPage />,
	},
	{
		path: "production-statistics",
		sidebar: () => <div>System Activity</div>,
		main: () => <ProductionStatisticsPage />,
	},
	{
		path: "email-recipients",
		sidebar: () => <div>Email Recipients</div>,
		main: () => <EmailRecipientsPage />,
	},
];

const sidebar = ({ option }: { option?: string }) => {
	const theme = useTheme();
	const hasPermissionTo = useHasPermission();

	return (
		<>
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Task List Settings
					</ListSubheader>
				}
			>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "task-list-areas"}
						component={Link}
						to="/configuration/task-list-areas"
					>
						<ListItemIcon>
							<ViewQuilt />
						</ListItemIcon>
						<ListItemText primary="Areas" />
					</ListItemButton>
				</ListItem>
			</List>
			<Divider />
			{hasPermissionTo(CRAFTS_PERMISSION) && (
				<>
					<List
						subheader={
							<ListSubheader
								style={{
									backgroundColor: theme.palette.background.paper,
									color: theme.palette.primary.main,
									fontWeight: 600,
								}}
							>
								Maintenance Settings
							</ListSubheader>
						}
					>
						<ListItem disablePadding>
							<ListItemButton
								selected={option === "crafts"}
								component={Link}
								to="/configuration/crafts"
							>
								<ListItemIcon>
									<Construction />
								</ListItemIcon>
								<ListItemText primary="Crafts" />
							</ListItemButton>
						</ListItem>
					</List>
					<Divider />
				</>
			)}
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Form Settings
					</ListSubheader>
				}
			>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "forms"}
						component={Link}
						to="/configuration/forms"
					>
						<ListItemIcon>
							<Assignment />
						</ListItemIcon>
						<ListItemText primary="Forms" />
					</ListItemButton>
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Document Settings
					</ListSubheader>
				}
			>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "shelves"}
						component={Link}
						to="/configuration/shelves"
					>
						<ListItemIcon>
							<Warehouse />
						</ListItemIcon>
						<ListItemText primary="Shelves" />
					</ListItemButton>
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Statistics
					</ListSubheader>
				}
			>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "statistics"}
						component={Link}
						to="/configuration/statistics"
					>
						<ListItemIcon>
							<BarChart />
						</ListItemIcon>
						<ListItemText primary="System Usage" />
					</ListItemButton>
				</ListItem>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "production-statistics"}
						component={Link}
						to="/configuration/production-statistics"
					>
						<ListItemIcon>
							<TrendingUp />
						</ListItemIcon>
						<ListItemText primary="System Activity" />
					</ListItemButton>
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Email Settings
					</ListSubheader>
				}
			>
				<ListItem disablePadding>
					<ListItemButton
						selected={option === "email-recipients"}
						component={Link}
						to="/configuration/email-recipients"
					>
						<ListItemIcon>
							<MailOutline />
						</ListItemIcon>
						<ListItemText primary="Email Recipients" />
					</ListItemButton>
				</ListItem>
			</List>
			<Divider />
		</>
	);
};
const customConfigurations: ConfigurationsType = [components, sidebar];

export { customConfigurations };
